import pluralize from 'pluralize';
import { Flex, Text } from '@mantine/core';
import { Button } from 'src/design-system/Button';
import { Modal } from 'src/design-system/Modal';

type Props = {
  opened: boolean;
  count: number;
  // What the count is counting. Without confirmation these are only speakers nobody has named,
  // and saying they "need reviewing" is vaguer than the truth.
  countMeans: 'unidentified' | 'unreviewed';
  onClose: () => void;
  onContinue: () => void;
};

export function CheckSpeakersModal({ opened, count, countMeans, onClose, onContinue }: Props) {
  const speakerCount = `${count} ${pluralize('speaker', count)}`;
  const state =
    countMeans === 'unidentified'
      ? `${count === 1 ? 'is' : 'are'} still unidentified`
      : `still ${count === 1 ? 'needs' : 'need'} reviewing`;
  const caveat =
    countMeans === 'unidentified'
      ? 'The meeting note may attribute statements to the wrong person.'
      : 'Until they’re confirmed, the meeting note may attribute statements to the wrong person.';

  return (
    <Modal opened={opened} onClose={onClose} title="Check the speakers">
      <Text size="sm" c="gray.7" mt="sm">
        {speakerCount} {state}. {caveat} Review them for the most accurate note, or continue and
        regenerate the note afterwards.
      </Text>

      <Flex justify="flex-end" align="center" gap="sm" mt="lg">
        <Button variant="secondary" size="sm" onClick={onClose}>
          Review speakers
        </Button>
        <Button variant="primary" size="sm" onClick={onContinue}>
          Continue anyway
        </Button>
      </Flex>
    </Modal>
  );
}
